import { render, staticRenderFns } from "./AfterWithdrawModal.vue?vue&type=template&id=19b53964&scoped=true&"
import script from "./AfterWithdrawModal.vue?vue&type=script&lang=js&"
export * from "./AfterWithdrawModal.vue?vue&type=script&lang=js&"
import style0 from "./AfterWithdrawModal.vue?vue&type=style&index=0&id=19b53964&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b53964",
  null
  
)

export default component.exports